const angular = require('angular');

const { productSaveToListComponentDefinition } = require('./product-save-to-list.component');
const { productSaveToListLegacyComponentDefinition } = require('./product-save-to-list-legacy.component');
const { productSaveToListNewComponentDefinition } = require('./product-save-to-list-new.component');

angular.module('wowApp.shop')
    .component('wowProductSaveToList', productSaveToListComponentDefinition)
    .component('wowProductSaveToListLegacy', productSaveToListLegacyComponentDefinition)
    .component('wowProductSaveToListNew', productSaveToListNewComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/productsavetolist/index.js